import React from "react";
import { Chip } from "@mui/material";
import type { EmailProvider } from "./emailHubApi";

const CONFIG: Record<EmailProvider, { label: string; bg: string; color: string; border: string }> = {
  microsoft: { label: "Microsoft 365", bg: "rgba(0,120,212,0.12)", color: "#0067b8", border: "rgba(0,120,212,0.35)" },
  google:    { label: "Google Workspace", bg: "rgba(234,67,53,0.12)", color: "#c5221f", border: "rgba(234,67,53,0.35)" },
};

/** Small provider chip for the inbox / settings. Falls back to Microsoft. */
const ProviderBadge: React.FC<{ provider?: EmailProvider | string | null; size?: "xs" | "sm" }> = ({ provider, size = "sm" }) => {
  const cfg = CONFIG[(provider as EmailProvider) || "microsoft"] ?? CONFIG.microsoft;
  return (
    <Chip
      label={cfg.label}
      size="small"
      sx={{
        height: size === "xs" ? 18 : 22,
        fontSize: size === "xs" ? 9.5 : 10.5,
        fontWeight: 700,
        bgcolor: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.border}`,
        "& .MuiChip-label": { px: 0.8 },
      }}
    />
  );
};

export default ProviderBadge;
